import { forwardRef, useEffect, useState, type FC } from "react";
import { Input, Loader, Modal, SelectPicker, Uploader } from "rsuite";
import { Warehouse } from "../../../models/inventory/warehouse";
import { Form, Button } from "rsuite";
import { errorToast, successToast } from "../../../utils/helper-ui";
import { BsCamera } from "react-icons/bs";
import { asyncLocalStorage } from "../../../utils/storage";
import { Company } from "../../../models/company/company";
import { getCompanies } from "../../../services/company/CompanyApi";
interface WarehouseFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Warehouse) => void;
  warehouse?: Warehouse;
}

const WarehouseForm: FC<WarehouseFormProps> = ({
  open,
  onClose,
  onSubmit,
  warehouse,
}) => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState<
    string | null | undefined
  >(null);
  const [data, setData] = useState<Warehouse>({
    id: "",
    name: "",
    code: "",
    description: "",
    address: "",
    phone: "",
    contact_person: "",
    contact_position: "",
    contact_title: "",
    contact_note: "",
  });
  const [uploading, setUploading] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    asyncLocalStorage.getItem("token").then((token) => {
      setToken(token);
    });
  }, []);

  const getAllCompanies = async (search?: string) => {
    try {
      const res = await getCompanies({ page: 1, size: 10, search });
      const data = await res.json();
      setCompanies(data.data.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setData(
      warehouse || {
        id: "",
        name: "",
        code: "",
        description: "",
        address: "",
        phone: "",
        contact_person: "",
        contact_position: "",
        contact_title: "",
        contact_note: "",
      }
    );
    getAllCompanies();
  }, [warehouse]);
  return (
    <Modal
      size={"lg"}
      open={open}
      onClose={() => {
        setSelectedCompanyId(null);
        onClose();
      }}
    >
      <Modal.Header>
        <Modal.Title>Warehouse Form</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className="w-full" layout="horizontal" fluid>
          <div className="form-group">
            <label>Company</label>
            <div className="input">
              <SelectPicker
                block
                data={companies}
                value={selectedCompanyId}
                onChange={(val) => {
                  setSelectedCompanyId(`${val}`);
                }}
                placeholder="Select a company"
                valueKey="id"
                labelKey="name"
                onSearch={(val) => {
                  if (val) {
                    getAllCompanies(val);
                  }
                }}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="e.g. Anytown Warehouse"
              value={data.name}
              onChange={(value) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <Input
              as={"textarea"}
              rows={4}
              name="description"
              placeholder="e.g. Anytown Warehouse is a storage facility located in Anytown."
              onChange={(value) => setData({ ...data, description: value })}
            />
          </div>
          <div className="form-group">
            <label>Code</label>
            <Input
              name="code"
              placeholder="e.g. WH001"
              value={data.code}
              onChange={(value) => setData({ ...data, code: value })}
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <Input
              as={"textarea"}
              rows={4}
              name="address"
              placeholder="e.g. 123 Warehouse Street, Anytown, USA"
              value={data.address}
              onChange={(value) => setData({ ...data, address: value })}
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <Input
              name="phone"
              placeholder="e.g. (123) 456-7890"
              value={data.phone}
              onChange={(value) => setData({ ...data, phone: value })}
            />
          </div>
          <div className="form-group">
            <label>Contact Person</label>
            <Input
              name="contact_person"
              placeholder="e.g. John Doe"
              value={data.contact_person}
              onChange={(value) => setData({ ...data, contact_person: value })}
            />
          </div>
          <div className="form-group">
            <label>Contact Position</label>
            <Input
              name="contact_position"
              placeholder="e.g. Warehouse Manager"
              value={data.contact_position}
              onChange={(value) =>
                setData({ ...data, contact_position: value })
              }
            />
          </div>
          <div className="form-group">
            <label>Contact Title</label>
            <Input
              name="contact_title"
              placeholder="e.g. Mr."
              value={data.contact_title}
              onChange={(value) => setData({ ...data, contact_title: value })}
            />
          </div>
          <div className="form-group">
            <label>Contact Note</label>
            <Input
              as={"textarea"}
              rows={4}
              name="contact_note"
              placeholder="e.g. John is the warehouse manager."
              value={data.contact_note}
              onChange={(value) => setData({ ...data, contact_note: value })}
            />
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              if (selectedCompanyId) {
                data.company_id = selectedCompanyId;
              }
              onSubmit(data!);
              setData({
                id: "",
                name: "",
                code: "",
                description: "",
                address: "",
                phone: "",
                contact_person: "",
                contact_position: "",
                contact_title: "",
                contact_note: "",
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default WarehouseForm;
